module.exports = __webpack_public_path__ + "images/190924f6f5e83641c85e14c4289a4a18af52d5a035c5a8681d95b9bd54251821.svg";